<template>
    <div class="non-responsive-table">
        <DataTable :value="FilteredData" ref="dt" dataKey="aid" class="dataTableData"
        v-model:selection="DataSelectedItems" @row-select="onRowSelect" @row-unselect="onRowUnselect"   
        paginator :rows="50" >            
        <!-- :rowsPerPageOptions="[10, 20, 50, 100, 200]" -->
            <template #header>
                <div class="grid headerGrid">
                    <div class="col-12 masterPlaceholder">
                        <div class="grid">
                            <div class="col-12 subPlaceholder">
                                <span class="p-input-icon-right">
                                    <i class="pi pi-search" />
                                    <InputText ref="searchInput" class="searchInputText" v-model="searchString" :placeholder="translated('keywordsearch')" @keyup="filterRecords" @focus="selectAllText" />
                                </span>                                                                
                            </div>    
                        </div>
                    </div>
                    <div class="col-12 masterPlaceholder">
                        <div class="grid">
                            <div class="col-12 sm:col-6 subPlaceholder">
                                <dropdown class="masterGroup" v-model="selectedGroup" @change="masterSelected" :options="MasterGroups" optionLabel="name" optionValue="id" :placeholder="translated('allGroups')" />                                
                            </div>
                            <div class="col-12 sm:col-6 subPlaceholder">
                                <div class="p-d-flex p-jc-between">
                                    <dropdown class="subGroup" v-model="selectedSubGroup" @change="subSelected" :options="SubGroups" optionLabel="name" optionValue="id" :placeholder="translated('allSubGroups')" />
                                </div>
                            </div>                                    
                        </div>
                    </div>
                    <!-- <div class="col-12 subPlaceholder">
                        <div class="p-d-flex p-jc-between">
                            <span class="p-input-icon-right">
                                <i class="pi pi-search" />
                               
                                <InputText ref="searchInput" v-model="searchString" :placeholder="translated('keywordsearch')" @keyup="filterRecords" @focus="handleInputFocus"/>
                            </span>
                        </div>
                    </div> -->
                    <div class="col-12 headerTitle">
                        <div class="newHeader">                            
                            <div class="newSelection"></div>
                            <!-- <div class="newGroup desktoponly">{{ translated('group').toUpperCase() }}</div> -->
                            <div class="newAnaliza">{{ translated('analysis').toUpperCase() }}</div>
                            <div class="newPrice">{{ translated('price').toUpperCase() }}</div>
                        </div>
                    </div>
                </div>
            </template>
            <Column selectionMode="multiple" headerClass="hSelection" bodyClass="dSelection"></Column>

            <Column headerClass="hDataColumn" bodyClass="dDataColumn" :header="translated('analysis').toUpperCase()">
                <template #body="slotProps">
                    <div class="cRowPlaceholder">
                        <!-- <div class="cGroupMaster desktoponly">
                            <div class="cGroup">
                                {{ getMasterGroupName(slotProps.data.mgid) }} 
                            </div>            
                            <div class="cSubGroup">
                                {{ getSubGroupName(slotProps.data.mgid, slotProps.data.sgid) }} 
                            </div>   
                        </div> -->
                        <div class="cName">
                            <div class="serviceName">{{ slotProps.data.name }}</div>  
                            <!-- <div class="mobileGroup mobileonly">{{ getSubGroupName(slotProps.data.mgid, slotProps.data.sgid) }} - {{ getSubGroupName(slotProps.data.mgid, slotProps.data.sgid) }} </div>   -->
                            <div class="serviceType">{{ slotProps.data.st }}</div>
                            <!-- <div>{{ getSubGroupName(slotProps.data.mgid, slotProps.data.sgid) }} - {{ getSubGroupName(slotProps.data.mgid, slotProps.data.sgid) }} </div> -->
                        </div>         
                        <div class="cPrice">
                            <div>{{ getPrice(slotProps.data.price) }}</div>
                        </div>                                          
                    </div>
                </template>  
            </Column>



            <!-- ZAKOMENTARISANO PRE IZMENE ZBOG PRIMEDBI KORISNIKA -- NIKOLA -->
            <!-- <Column header="group" headerClass="desktoponly hMasterGroup" bodyClass="desktoponly" :style="{width: '150px'}">
                <template #body="slotProps">
                    {{ getMasterGroupName(slotProps.data.mgid) }}                  
                </template>  
            </Column>
            <Column header="subgroup" headerClass="desktoponly hSubGroup" bodyClass="desktoponly" :style="{width: '150px'}" >
                <template #body="slotProps">
                    {{ getSubGroupName(slotProps.data.mgid, slotProps.data.sgid) }}                  
                </template>              
            </Column> -->
            <!-- <Column header="Ime" headerClass="desktoponly hName" bodyClass="desktoponly" >
                <template #body="slotProps">
                    <div class="serviceType">
                        <div class="serviceName">{{ slotProps.data.name }}</div>    
                        <div class="serviceType">{{ slotProps.data.st }}</div>
                    </div>                    
                </template>              
            </Column> -->
            <!-- <Column header="Ime Mobile" headerClass="mobileonly hNameMobile" bodyClass="mobileonly" :style="{width: '80%'}">
                <template #body="slotProps">
                    <div class="serviceType">
                        <div class="serviceName">{{ slotProps.data.name }}</div>   
                        <div class="serviceType">{{ slotProps.data.st }}</div>
                    </div>                    
                </template>              
            </Column>            
            <Column header="Cena" headerClass="hPrice" bodyClass="bPrice" :style="{width: '120px'}">
                <template #body="slotProps">
                    {{ getPrice(slotProps.data.price) }}
                </template>              
            </Column> -->

        </DataTable>
    </div>
    
</template>


<script>
import { computed } from "vue";
import store from "@/store";
export default {            
    emits: ['selectionChanged'],
    props: {
        MasterGroups: [],
        GridData: [],
        BlodId: null,
        BlodReletedItems: [],
    }, 
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
            selectedGroup: null,
            selectedSubGroup: null,
            SubGroups: null,
            searchString: '',
            FilteredData: [], 
            DataSelectedItems: null           
        }
    },
    mounted() {        
        this.$nextTick(() => {
            // console.log('Next TICK:', this.$refs.searchInput.$el);
            const input = this.$refs.searchInput.$el;
            if (input) input.focus();
        });        
    },
    methods: {
        selectAllText(event) {
            // Using $nextTick to ensure that the selection occurs after the input field is focused
            this.$nextTick(() => {
                event.target.select();
            })
        },
        // searchSelected() {            
        //     // Get the input element
        //     const inputElement = this.$refs.searchInput;
        //     // this.searchString='';
            
        //     // const inputElement = this.$refs.searchInput.$el; 

        //     if (inputElement && inputElement instanceof HTMLInputElement) {
        //         // Focus the input
        //         inputElement.focus();

        //         // Set the selection range
        //         const length = inputElement.value.length;
        //         inputElement.setSelectionRange(length, length);            
        //     }
        // },
        handleInputFocus(event) {
            // Select all content in the input
            // event.target.select();
            this.searchString='';
            this.filterRecords();

        },
        masterSelected() {
            this.SubGroups = this.MasterGroups.find(x => x.id === this.selectedGroup).subGroups;
            this.selectedSubGroup = null;
            this.filterRecords();
        },
        subSelected() {
            this.filterRecords();
            //this.FilteredData = this.GridData.filter(x => x.mgid === this.selectedGroup && x.sgid === this.selectedSubGroup);
        },
        filterRecords() {
            /*
            let tmpTest = "Q01";
            let tmpTest1 = "02";
            let tmpTest2 = '03';
            // console.log(tmpTest);
            // console.log(tmpTest1);
            // console.log(tmpTest2);
*/
            // console.log(this.selectedGroup);
            // console.log(this.selectedSubGroup);
            //this.FilteredData = this.GridData.filter(x => x.mgid == 2);
            let tmpSearchedAndSorted = this.GridData.filter(x => 
                (this.selectedGroup === null || x.mgid == Number(this.selectedGroup)) && 
                (this.selectedSubGroup === null || x.sgid == Number(this.selectedSubGroup)) && 
                (this.searchString.trim() === '' || x.name.toLowerCase().includes(this.searchString.trim().toLowerCase()))
            );

            if(this.searchString.trim() != '') {
                this.FilteredData = tmpSearchedAndSorted.sort((a, b) => {
                    const aStartsWithSearchString = a.name.toLowerCase().startsWith(this.searchString.trim().toLowerCase());
                    const bStartsWithSearchString = b.name.toLowerCase().startsWith(this.searchString.trim().toLowerCase());

                    // If both items start with the search string or both do not, sort them alphabetically
                    if (aStartsWithSearchString === bStartsWithSearchString) {
                        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                    }
                    // If only 'a' starts with the search string, place 'a' before 'b'
                    if (aStartsWithSearchString) {
                        return -1;
                    }
                    // If only 'b' starts with the search string, place 'b' before 'a'
                    return 1;
                });

                return;
            }

            this.FilteredData = tmpSearchedAndSorted;
        },        
        onRowSelect(rowdata) {
            debugger;
            if(rowdata.data.aid == this.BlodId) {                
                this.DataSelectedItems = this.DataSelectedItems.filter(x => x.aid !== this.BlodId);
            } else {
                // Preverim ali ta storitev zahteva vađenje krvi
                const testEl = this.BlodReletedItems.find(x => x == rowdata.data.aid);                
                if(testEl != undefined) {
                    const kriEl = this.GridData.find(x => x.aid == this.BlodId);
                    const tmpBlodEl = this.DataSelectedItems.find(x => x.aid == this.BlodId);
                    if(tmpBlodEl === undefined) {
                        this.DataSelectedItems.unshift(kriEl);    
                    }                    
                }
            };
            this.$emit('selectionChanged', this.DataSelectedItems);

            //this.searchSelected();
        },
        onRowUnselect(rowdata) {
            // console.log('onRowUnselect');
            // console.log(rowdata);
            
            this.removeBlodIfNotNeeded();
            this.$emit('selectionChanged', this.DataSelectedItems);
        },

        removeBlodIfNotNeeded(){
            debugger;

            for(let i = 0; i < this.DataSelectedItems.length; i++) {
                if(this.DataSelectedItems[i].aid != this.BlodId) {
                    const testEl = this.BlodReletedItems.find(x => x == this.DataSelectedItems[i].aid);  
                    if(testEl != undefined) {                        
                        const tmpBlodEl = this.DataSelectedItems.find(x => x.aid == this.BlodId);
                        if(tmpBlodEl === undefined) {
                            const kriEl = this.GridData.find(x => x.aid == this.BlodId);
                            this.DataSelectedItems.unshift(kriEl);    
                        }  
                        return;
                    }
                        
                }
            }
            
            this.DataSelectedItems = this.DataSelectedItems.filter(x => x.aid !== this.BlodId);
        },
        RemoveItem(id){
            if(id == this.BlodId) return;

            this.DataSelectedItems = this.DataSelectedItems.filter(x => x.aid !== id);
            this.removeBlodIfNotNeeded();
            this.$emit('selectionChanged', this.DataSelectedItems);
        },
        addAnalysisItems(array){
            debugger;
            this.DataSelectedItems = array;
            this.$emit('selectionChanged', this.DataSelectedItems);
        },
        onSelectAllChange(){
            // console.log('onSelectAllChange');
        },
        getMasterGroupName(id) {
            if(this.MasterGroups === null) return '';

            var el = this.MasterGroups.find(x => x.id === id);
            if(el === undefined) return '';
            return el.name;
        },
        getSubGroupName(masterid, id) {
            let el = this.MasterGroups.find(x => x.id === masterid);
            let sel = el.subGroups.find(x => x.id === id);

            if(sel === undefined) return '';

            return sel.name;
        },
        formatCurrency(value) {
            // return value.toLocaleString('rs-RS', {style: 'currency', currency: 'RSD'});
            let formatted = value.toLocaleString('rs-RS', {style: 'currency', currency: 'RSD'});
            formatted = formatted.replace(/(^\D*)(\d.*\d)(\D*$)/, "$2 $1").trim();
            return formatted;
        },        
        getPrice(value) {
            // const formatter = new Intl.NumberFormat('sr-RS', {
            //     style: 'currency',
            //     currency: 'RSD',
            // });
            // return formatter.format(value);

            return this.formatCurrency(value);
        },
    },
    watch: {
        GridData: {
            immediate: true,
            handler(newVal) {
                let sortedData = newVal.sort((a, b) => {
                    let nameA = a.name.toLowerCase();
                    let nameB = b.name.toLowerCase();

                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                })
                this.FilteredData = [...sortedData];
            },
        },
    },    
}
</script>


<style>

.p-datatable > .p-datatable-wrapper {
    overflow: auto;
    overflow-x: hidden !important;
}
.non-responsive-table.tableAnalysis span.p-column-title { display:none !important}
.non-responsive-table.tableAnalysis .p-datatable-header { padding-left: 0px;padding-right: 0px;
}


/* table thead tr th  .p-checkbox.p-component {
    display: none;
} */
.p-dropdown.p-component.p-inputwrapper.masterGroup {
    min-width: 100%;
}
.p-dropdown.p-component.p-inputwrapper.subGroup {
    width: 100%;
    margin-left: 0px;
}
.masterPlaceholder {padding-top: 0px; padding-left:20px; padding-right: 20px;}
.subPlaceholder {/*padding-right: 20px; padding-right: 10px; padding:20px; */ position: relative;}
span.p-input-icon-right i {
    position: absolute;
    margin-top: 12px;
    float: right;
    /*  margin-left: calc( 100% - 40px ); */
    right: 15px;
}

.col-4.searchPlaceholder input {
    position: relative;
    float: right;
}

/* .col-4.searchHolder {
    align-items: self-end;
    align-self: self-end;
} */

/* .p-d-flex.p-jc-between {
    position: relative;
    float: right;
} */
.newSelection, .newGroup, .newAnaliza {
    position: relative;
    float: left;
    height: 20px;
}
.newSelection { width: 50px;
}
.newGroup { width: 250px;
}
.newAnaliza { width: auto;
}
.newPrice { position: relative; float: right; width: 50px; height: 20px;text-align:end;}
.cGroupMaster.desktoponly { position: relative; float: left; width: 250px;
}
.cName {position: relative; float: left; padding-right: 5px;}
/* .cPrice {position: relative;float: right;margin-right: 20px;width: 100px;text-align: right;font-weight: 600;} */
.cPrice {float: right;margin-right: 5px;font-weight: 600; width: 90px; text-align: end;}
/*.cPrice {position: relative;float: right;margin-right: 310px;width: 100px;text-align: right;}*/
/* .serviceName {white-space: nowrap;overflow: hidden;text-overflow: ellipsis;} */
td.p-selection-column {
    /* position: relative; */
    /* float: left; */
    /* width: 50px; */
}
td.dDataColumn {
    /* position: relative; */
    /* float: left; */
    /* width: 100% !important; */
}
.non-responsive-table .p-datatable .p-datatable-thead {display: none;}

/* .non-responsive-table .p-datatable .p-datatable-tbody > tr > td.dDataColumn { float: left; width: calc(100% - 50px) !important; } */
.non-responsive-table .p-datatable .p-datatable-tbody > tr > td.p-selection-column { float:left; width: 50px !important;
}
.non-responsive-table .p-datatable .p-datatable-tbody > tr > td.dDataColumn { float: left; width: calc(100% - 50px) !important;
}
.non-responsive-table .p-datatable .p-datatable-thead > tr > th.hSelection { float:left; width: 50px !important;
}
.non-responsive-table .p-datatable .p-datatable-thead > tr > th.hDataColumn { float: left; width: calc(100% - 50px) !important;
}
td.dSelection, td.dDataColumn {height: 80px;}
th.hSelection, th.hDataColumn {height: 40px;}

/* span.p-column-title { display: none !important; } */
.headerGrid.grid {margin-left: 0px !important; margin-right: 0px !important; /*padding-top: 30px;*/}

/* .p-datatable-header {padding: 0px !important;margin: 0px !important;} */
.headerTitle {background: #ced4da;color: black;}
.newHeader {padding-left: 5px;padding-right: 13px;}
.subPlaceholder input {width: 100%;float: left;}
.subPlaceholder .p-jc-between {width: 100%;}
.subPlaceholder .p-jc-between span {width: 100%;}
.brojanalizaplaceholder, .iznosanalizaplaceholder {
    position: relative;
    float: left;
    background: #ebc7c7;
    padding: 15px;
    border-radius: 5px;
    font-weight: 600;
    font-size: 1.4em;
}
.iznosanalizaplaceholder {
    background: #c0a2a2;
    float: right;
}

.cRowPlaceholder {
    display: flex;
    justify-content: space-between;
}

@media screen and (min-width: 200px) and (max-width: 360px)
{
    label.iznosanaliza {font-size: 1.10em !important;}
    .cRowPlaceholder {display: initial !important;}
    .cPrice {clear:left;float: left;}
    .newPrice {display: none;}
}

@media screen and (max-width: 600px)
{
    .grid.col-12.buttonplaceholder {margin-left: 3px !important;}
    td.dDataColumn {padding-left: 0px !important;}
}

/* @media screen and (min-width: 361px) and (max-width: 400px)
{
    .desktoponly {display: none;}
}
@media screen and (min-width: 401px) and (max-width: 500px)
{
    .desktoponly {display: none;}
}
@media screen and  (min-width: 501px) and (max-width: 600px)
{
    .desktoponly {display: none;}
} */
/* @media screen and (min-width: 960px)
{
    .mobileonly {display: none;}
} */

/*
input#searchInputDiv {
    height: 35px;
    padding: 7px;
    border: 1px solid lightgrey;
    border-radius: 5px;
}
*/



</style>